// Types
import type { I_apiGetProducts, I_apiGetProducts_Return } from "./apiGetProducts.types";

// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";

/** Получить Продукты */
const apiGetProducts: I_apiGetProducts = async (aboutProducts) => {
    const fetchData = await axios.post<I_apiGetProducts_Return>(
        I_AXIOS.STAGE_API_HOST + "/api/tin/v1/site/quest/calc/products",
        aboutProducts,
    );
    // console.log(fetchData.data);
    return fetchData.data;
};

export default apiGetProducts;
